(() => {
  if (window.__cornerstoneProductLabelsInitialised) return;
  window.__cornerstoneProductLabelsInitialised = true;

  const syncProductLabels = (activeMediaId) => {
    document.querySelectorAll('[data-section-type="product"]').forEach((section) => {
      const source = section.querySelector('[data-product-pdp-label-source]');
      if (!source) return;

      const markup = source.innerHTML.trim();
      if (activeMediaId) {
        section.querySelectorAll('[data-product-pdp-label-slot]').forEach((slot) => {
          if (slot.dataset.labelMediaId === String(activeMediaId)) {
            slot.dataset.labelMediaActive = 'true';
          } else {
            delete slot.dataset.labelMediaActive;
          }
        });
      }
      section.querySelectorAll('[data-product-pdp-overlay-labels]').forEach((target) => {
        target.innerHTML = markup;
        const slot = target.closest('[data-product-pdp-label-slot]');
        target.hidden = markup === '' || (slot && slot.dataset.labelMediaActive !== 'true');
      });
    });
  };

  document.addEventListener('product:variant-change', (event) => {
    const mediaId = event.detail?.variant?.featured_media?.id;
    requestAnimationFrame(() => syncProductLabels(mediaId));
  });
  document.addEventListener('shopify:section:load', () => requestAnimationFrame(syncProductLabels));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncProductLabels, { once: true });
  } else {
    syncProductLabels();
  }
})();
